import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

// eslint-disable-next-line import/prefer-default-export

export const getDefaultConfigOfTable = (payload: any) =>
  sendPost("/api-client/table/default-config", payload);

export const updateTableConfigDefault = (payload: any) =>
  sendPost("/api-client/table/update-default-config", payload);

export const syncDataDefaultConfig = (payload: any) =>
  sendPut("/api-client/table/sync-data", payload);

export const updateIndexTable = (payload: any) =>
  sendPut("/api-client/table/update-index-table", payload);

export const getListIndexTable = (payload: any) =>
  sendGet("/api-client/table/index-table", payload);

export const updateEntropy = (payload: any) =>
  sendPost("/api-client/table/update-entropy", payload);

export const getListConfig = () => sendGet("/api-client/table/config");
